import { cn } from '@core-utils/cn';
import { FormEvent, forwardRef } from 'react';

import styles from './Form.module.scss';

type FormProps = React.HTMLAttributes<HTMLFormElement>;

const Form = forwardRef<HTMLFormElement, FormProps>(function Form(
    { className, onSubmit, ...props },
    ref,
) {
    // * Either use provided onSubmit handler or disable default submit behavior
    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        if (onSubmit) onSubmit(e);
        else e.preventDefault();
    };

    return (
        <form
            ref={ref}
            onSubmit={handleSubmit}
            className={cn(styles.Form, 'form', className)}
            {...props}
        />
    );
});

export { Form };
